jQuery('document').ready(function ($) {



});


// WEBPACK FOOTER //
// ./assets/js/app.js